import { I18n, useI18n } from 'next-localization';

export const useLocale = (): string => useI18n().locale();

/**
 * Returns translations for a specific locale and page.  Connected to specific /locales
 * files via getStaticProps() using addLanguageAndDictionaryToProps().
 */
export const useTranslate = <Table>(): I18n<Table>['t'] => useI18n().t;
